'use client';

import { c as _c } from "react/compiler-runtime";
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { cn } from '~/utils';
export const HoverCard: React.FC<React.ComponentProps<typeof HoverCardPrimitive.Root>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const HoverCardTrigger: React.FC<React.ComponentProps<typeof HoverCardPrimitive.Trigger>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const HoverCardContent: React.FC<React.ComponentProps<typeof HoverCardPrimitive.Content> & {
  sideOffset?: number;
  showArrow?: boolean;
}> = t0 => {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      showArrow: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const showArrow = t3 === undefined ? false : t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("z-popovers w-64 rounded-xl border bg-white p-4 shadow-lg outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showArrow) {
    t5 = showArrow ? <HoverCardPrimitive.Arrow className="fill-white stroke-blue-100 stroke-1" width={18} height={10} /> : null;
    $[8] = showArrow;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== align || $[11] !== props || $[12] !== sideOffset || $[13] !== t4 || $[14] !== t5) {
    t6 = <HoverCardPrimitive.Portal><HoverCardPrimitive.Content data-slot="hover-card-content" align={align} sideOffset={sideOffset} className={t4} {...props}>{props.children}{t5}</HoverCardPrimitive.Content></HoverCardPrimitive.Portal>;
    $[10] = align;
    $[11] = props;
    $[12] = sideOffset;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};